module.exports = __webpack_public_path__ + "img/bg.ee58846a.svg";